<template><WorkspaceSites /></template>
<script setup>
import WorkspaceSites from '../ai/WorkspaceSites.vue'
</script>
